import { styled } from '@mui/material'

const MenuLogo = styled('img')({
  minWidth: '220px',
  maxWidth: '220px',
  padding: '16px'
})

export default MenuLogo
